import { Tooltip } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Button from '@material-ui/core/Button';
import { BASE_URL } from "../../constants.tsx"

const Clipboard = ({ text, formName, loading,setToLocal }) => {
    const [copy, setCopy] = useState("Copy");

    return (
        <React.Fragment> <Tooltip title={copy} placement="top">
            <a target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black" }}
            >
                <CopyToClipboard
                    text={`${BASE_URL + `/` + formName + `/` + text}`}
                    onCopy={() => {
                        setCopy("Copied!");
                        if(setToLocal){
                        localStorage.setItem('copyUrlParams', `${BASE_URL + `/` + formName + `/` + text}`);
                        }else{
                            sessionStorage.setItem('copyUrlParams', `${BASE_URL + `/` + formName + `/` + text}`);
                        }
                    }}
                    onMouseEnter={() => setCopy("Copy")}
                >
                    <Button style={{ textTransform: "initial" }} variant="contained" color="secondary" disabled={loading ? false : true}>Copy url</Button>
                </CopyToClipboard>


            </a>
        </Tooltip>
        </React.Fragment >
    )
}
export default Clipboard